import React from 'react';
import styled from 'styled-components';

export type PartnerLogoAsset = {
  url: string;
  alt?: string | null;
  responsiveImage?: {
    src?: string | null;
    srcSet?: string | null;
    sizes?: string | null;
    alt?: string | null;
  } | null;
};

const Image = styled.img`
  display: block;
  width: auto;
  max-width: 100%;
  object-fit: contain;
`;

interface Props {
  logo?: PartnerLogoAsset | null;
  fallbackAlt?: string | null;
  className?: string;
}

const PartnerLogo = ({ logo, fallbackAlt, className }: Props) => {
  if (!logo) {
    return null;
  }

  const image = logo.responsiveImage;

  return (
    <Image
      className={className}
      src={image?.src ?? logo.url}
      srcSet={image?.srcSet ?? undefined}
      sizes={image?.sizes ?? undefined}
      alt={image?.alt ?? logo.alt ?? fallbackAlt ?? ''}
    />
  );
};

export default PartnerLogo;
